/* Product-local social proof. Customer review text is never translated or rewritten. */
(() => {
  if (window.dvReviewPlacementLoaded) return;
  window.dvReviewPlacementLoaded = true;
  let pendingNavigation = location.hash === '#judgeme_product_reviews';
  function navigateToReviews(widget) {
    if (!pendingNavigation || !widget.querySelector('.jdgm-rev-widg__header') || !widget.offsetHeight) return;
    widget.setAttribute('tabindex', '-1');
    widget.focus({ preventScroll: true });
    widget.scrollIntoView({ behavior: 'auto', block: 'start' });
    pendingNavigation = false;
  }
  const words = new Map([
    ['Verified', 'Staðfest kaup'], ['Verified Checkmark', 'Staðfest kaup'],
    ['Write a review', 'Skrifa umsögn'], ['See all reviews', 'Sjá allar umsagnir'],
    ['Sort by', 'Raða eftir'], ['Most Recent', 'Nýjustu fyrst'],
    ['Highest Rating', 'Hæsta einkunn fyrst'], ['Lowest Rating', 'Lægsta einkunn fyrst'],
    ['Only Pictures', 'Aðeins með myndum'], ['Pictures First', 'Myndir fyrst'],
    ['Videos First', 'Myndskeið fyrst'], ['Most Helpful', 'Gagnlegastar fyrst'],
    ['Review collected via store invitation', 'Umsögn eftir boð frá verslun'],
    ['Read more', 'Lesa meira'], ['Read less', 'Sjá minna'],
    ['Be the first to write a review', 'Vertu fyrst til að skrifa umsögn'],
    ['Customer Reviews', 'Umsagnir kaupenda'],
    ['Next page', 'Næsta síða'], ['Previous page', 'Fyrri síða']
  ]);
  function translate(value) {
    const clean = value.trim();
    let result = words.get(clean);
    if (!result && /^Based on \d+ reviews?$/.test(clean)) result = clean.replace(/^Based on (\d+) reviews?$/, '$1 umsagnir');
    if (!result && /^[\d.]+ out of [\d.]+$/.test(clean)) result = clean.replace(' out of ', '/').replaceAll('.', ',');
    if (!result && /^Average rating is [\d.]+ stars$/.test(clean)) result = clean.replace(/^Average rating is ([\d.]+) stars$/, 'Meðaleinkunn $1 af 5 stjörnum').replaceAll('.', ',');
    if (!result && /^[1-5] star review$/.test(clean)) result = clean.replace(/^([1-5]) star review$/, '$1 stjörnu umsögn');
    if (!result && /^\d+% \(\d+\) reviews with [1-5] star rating$/.test(clean)) result = clean.replace(/^(\d+)% \((\d+)\) reviews with ([1-5]) star rating$/, '$1% ($2) umsagnir með $3 stjörnur');
    return result ? value.replace(clean, result) : value;
  }
  function localize(widget) {
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement.closest('.jdgm-rev__body,.jdgm-rev__title,.jdgm-rev__author,script,style,textarea')) continue;
      const value = translate(node.nodeValue);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
    widget.querySelectorAll('[aria-label],[alt]').forEach(element => {
      if (element.closest('.jdgm-rev__body,.jdgm-rev__title')) return;
      for (const key of ['aria-label', 'alt']) {
        const before = element.getAttribute(key);
        if (before && translate(before) !== before) element.setAttribute(key, translate(before));
      }
    });
  }
  function feature(widget) {
    const slot = document.querySelector('[data-dv-review-quote]');
    if (!slot) return;
    const review = [...widget.querySelectorAll('.jdgm-rev[data-verified-buyer="true"]')].find(item => {
      const text = item.querySelector('.jdgm-rev__body')?.textContent.trim();
      return item.querySelector('.jdgm-rev__rating')?.dataset.score === '5' && text && text.length <= 180;
    });
    if (!review) { slot.hidden = true; slot.replaceChildren(); delete slot.dataset.reviewId; return; }
    const body = review.querySelector('.jdgm-rev__body').textContent.trim();
    const author = review.querySelector('.jdgm-rev__author')?.textContent.trim() || 'Kaupandi';
    const stamp = `${review.dataset.reviewId}|${body}|${author}`;
    if (slot.dataset.reviewId === stamp) return;
    const label = document.createElement('div');
    label.className = 'dv-review-quote__label';
    label.textContent = '★★★★★ · Úr umsögnum kaupenda';
    const quote = document.createElement('blockquote');
    quote.textContent = `„${body}“`;
    const byline = document.createElement('p');
    byline.textContent = `${author.split(/\s+/)[0]} · Staðfest kaup`;
    const timestamp = review.querySelector('time')?.getAttribute('datetime');
    if (timestamp && !Number.isNaN(Date.parse(timestamp))) {
      const date = new Date(timestamp);
      const months = ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember'];
      byline.textContent += ` · ${date.getUTCDate()}. ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
    }
    const link = document.createElement('a');
    link.href = '#judgeme_product_reviews';
    link.textContent = 'Lesa umsagnir';
    const linkRow = document.createElement('p');
    linkRow.append(link);
    slot.replaceChildren(label, quote, byline, linkRow);
    slot.dataset.reviewId = stamp;
    slot.hidden = false;
  }
  function attach(widget) {
    if (widget.dataset.dvReviewEnhanced) return;
    widget.dataset.dvReviewEnhanced = 'true';
    const observer = new MutationObserver(update);
    function update() {
      observer.disconnect();
      localize(widget);
      feature(widget);
      navigateToReviews(widget);
      observer.observe(widget, { childList: true, subtree: true, characterData: true });
    }
    update();
  }
  function findWidget() {
    const widget = document.querySelector('#judgeme_product_reviews');
    if (widget) attach(widget);
    return Boolean(widget);
  }
  if (!findWidget()) {
    const waiting = new MutationObserver(() => { if (findWidget()) waiting.disconnect(); });
    waiting.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#judgeme_product_reviews"]');
    if (!link) return;
    event.preventDefault();
    pendingNavigation = true;
    history.replaceState(null, '', '#judgeme_product_reviews');
    const widget = document.querySelector('#judgeme_product_reviews');
    if (widget) navigateToReviews(widget);
  });
})();
